import React from 'react';
import { CloudIcon, FogIcon, RainIcon, SnowIcon, SunIcon } from '../icons/WeatherIcons';

const WeeklyForecast = ({ weatherData }) => {
  if (!weatherData.forecast) {
    return (
      <div className="bg-white/70 backdrop-blur-sm p-6 rounded-2xl">
        <p>No forecast data available</p>
      </div>
    );
  }

  const getWeatherIconType = (weatherCode) => {
    if (weatherCode >= 71 && weatherCode <= 77) return 'snow';
    if ((weatherCode >= 51 && weatherCode <= 67) || (weatherCode >= 80 && weatherCode <= 82)) return 'rain';
    if (weatherCode === 2 || weatherCode === 3) return 'cloud';
    if (weatherCode === 45 || weatherCode === 48) return 'fog';
    return 'sun';
  };

  const getWeatherDescription = (weatherCode) => {
    if (weatherCode >= 71 && weatherCode <= 77) return 'Snowy';
    if ((weatherCode >= 51 && weatherCode <= 67) || (weatherCode >= 80 && weatherCode <= 82)) return 'Rainy';
    if (weatherCode === 2 || weatherCode === 3) return 'Cloudy';
    if (weatherCode === 45 || weatherCode === 48) return 'Foggy';
    return 'Clear';
  };

  const formatDay = (isoString, timezoneFull) => {
    if (!isoString || !timezoneFull) return '—';
    const date = new Date(isoString);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      timeZone: timezoneFull
    });
  };

  const formatDate = (isoString, timezoneFull) => {
    if (!isoString || !timezoneFull) return '—';
    const date = new Date(isoString);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      timeZone: timezoneFull
    });
  };

  // Get all forecast days (typically 7 days)
  const forecastDays = [];
  const maxDays = Math.min(7, weatherData.forecast.time?.length || 0);
  for (let i = 0; i < maxDays; i++) {
    forecastDays.push({
      day: formatDay(weatherData.forecast.time[i], weatherData.timezoneFull),
      date: formatDate(weatherData.forecast.time[i], weatherData.timezoneFull),
      weatherCode: weatherData.forecast.weathercode?.[i] || 0,
      tempMax: weatherData.forecast.temperature_2m_max?.[i] != null 
        ? Math.round(weatherData.forecast.temperature_2m_max[i]) 
        : null,
      tempMin: weatherData.forecast.temperature_2m_min?.[i] != null 
        ? Math.round(weatherData.forecast.temperature_2m_min[i]) 
        : null,
      description: getWeatherDescription(weatherData.forecast.weathercode?.[i] || 0),
      iconType: getWeatherIconType(weatherData.forecast.weathercode?.[i] || 0)
    });
  }

  return (
    <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl">
      <h3 className="text-2xl font-semibold text-gray-800 m-0 mb-4">Weekly Forecast</h3>
      <div className="grid md:grid-cols-3 lg:grid-cols-7 gap-3">
        {forecastDays.map((day, index) => (
          <div 
            key={index} 
            className="relative grid p-3 rounded-xl bg-white"
          >
              <p className="text-md uppercase font-semibold text-gray-800">{day.day}</p>
              <p className="text-xs text-gray-600">{day.date}</p>
            <div className="absolute top-2 right-0 w-14 flex items-center justify-center text-[#1F4A73]">
              {day.iconType === 'rain' ? (
                <RainIcon className="w-8 h-8" title="Rain" />
              ) : day.iconType === 'cloud' ? (
                <CloudIcon className="w-8 h-8" title="Cloud" />
              ) : day.iconType === 'fog' ? (
                <FogIcon className="w-8 h-8" title="Fog" />
              ) : day.iconType === 'snow' ? (
                <SnowIcon className="w-8 h-8" title="Snow" />
              ) : (
                <SunIcon className="w-8 h-8" title="Sun" />
              )}
            </div>
            <div className="flex-1 text-md text-gray-700">{day.description}</div>
            <div className="text-lg font-semibold text-gray-800 min-w-[80px] text-right">
              {day.tempMax}°{weatherData.temperatureUnit === 'fahrenheit' ? 'F' : 'C'} / {day.tempMin}°{weatherData.temperatureUnit === 'fahrenheit' ? 'F' : 'C'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklyForecast;

